import React, { useState } from 'react';
import './booking.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

import Nav from '../components/layout/nav';

const Booking = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const ticket = location.state?.ticket;
  const quantity = location.state?.quantity || 1;

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: ''
  });

  if (!ticket) {
    return (
      <div className="hcontainer bookingbg">
        <h1>No Ticket Selected</h1>
        <button onClick={() => navigate(-1)}>GO BACK</button>
      </div>
    );
  }

  const total =
    parseFloat(ticket.price.replace(/[^0-9.]/g, '')) * quantity;

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleBooking = async () => {
    if (!form.name || !form.email || !form.phone) {
      alert('Please fill all fields');
      return;
    }

    setLoading(true);

    const { error } = await supabase.from('ticket_orders').insert([
      {
        name: form.name,
        email: form.email,
        phone: form.phone,
        title: ticket.title,
        price: ticket.price,
        quantity,
        total,
        image: ticket.image
      }
    ]);

    setLoading(false);

    if (error) {
      alert(error.message);
      return;
    }
    setSuccess(true);

    setForm({ name: '', email: '', phone: '' });
  };

  return (
    <div className="hcontainer bookingbg">
      <div className="bookingoverlay">

        <div className="bookingtop">
          <div
            className="myticketback"
            onClick={() => navigate(-1)}
          />
          <h5>Booking</h5>
        </div>

        <img src={ticket.image} className="bookingimg" alt="" />

        <div className="bookingcard">

          <h3>{ticket.title}</h3>

          <input
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
          />

          <input
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />

          <input
            name="phone"
            placeholder="Phone"
            value={form.phone}
            onChange={handleChange}
          />

          <h4>Total: {ticket.price} × {quantity}</h4>
          <h2>${total}</h2>
          {success && (
            <div className="successmsg">
               Booking Successful!
            </div>
          )}

          <button
            className="confirmbtn"
            onClick={handleBooking}
            disabled={loading}
          >
            {loading ? "BOOKING..." : "CONFIRM BOOKING"}
          </button>

        </div>

      </div>

      <Nav />
    </div>
  );
};

export default Booking;